import {useBasketStore} from './useStore'

export const useItemsUnavailable = () => {
  const {basket} = useBasketStore()
  return basket?.c_previouslyRemovedItems?.length > 0
}
